import { useContext, useEffect, useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import ContentPage from "../../Content";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
const customStyles = CustomerStyle();
function RolePage(){
    const [errors,setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);

    const columns = [
        {
            name: 'ID',
            selector: (row,index) => index+1,
            sortable: true,
        },
        {
          name: 'LIBELLE',
          selector: row => row.name,
          sortable: true,
        },
    
        {
            name: "Action",
            selector : row => (
                <>
                    <Link className="btn btn-primary btn-sm mx-1" to={`/edit-role-page/${row.id}`}><i class="fa-solid fa-pen"></i></Link>
                    {/* <button className="btn btn-danger btn-sm" onClick={()=>deleteItem(row.id)}><i class="fa-solid fa-trash"></i></button> */}
                </>
            )
          },

    ];

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
    if(user && permissions && !can(permissions,'LISTE DES ROLES ET PERMISSIONS')){
        navigate('/page-no-found');
    }
    },[user]);
    
    useEffect(()=>{
        fetchRoleList();
    },[]);

    const fetchRoleList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/role-list',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{

                if(resp.status == 200){
                    setItemsList(resp.data.data);
                    setItemsListFilter(resp.data.data);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    const handleFilter=(event)=>{
        const datas = itemsListFilter.filter(row => row.name.toLowerCase().includes(event.target.value.toLowerCase()));
        setItemsList(datas);
    }

    return (
        <>
        <ContentPage>
        <div class="page-header flex-wrap">
        <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
            <div class="d-flex align-items-center">
              <a href="#">
                <p class="m-0 pr-3">Paramètres</p>
              </a>
              <a class="pl-3 mr-4" href="#">
                <p class="m-0">Listes des rôles</p>
              </a>
            </div>
            {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
              <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
          </div>
          <div class="header-left">
            {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-role"> Ajouter un role</Link> */}
            {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
          </div>
          
        </div>

        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
            <div class="card-header bg-warning bg-gradient">
                  <div class="row">
                      <div class=" col-lg-3 col-md-6">
                          <input type="search" class="form-control " placeholder="Reference..." onChange={handleFilter}/>
                      </div>
              </div>
              </div>
              <div class="card-body">
                <h4 class="card-title">ROLES</h4>
                <div class="table-responsive">
                <DataTable 
                      columns={columns} 
                      data={itemsList}
                      customStyles={customStyles}
                      pagination
                      selectableRows
                      progressPending={loading}
                      progressComponent={
                          <>
                          <div class="text-center">
                              <div class="spinner-border" role="status">
                              {/* <span class="visually-hidden">Loading...</span> */}
                              </div>
                          </div>
                          </>
                      } 
                  />
                </div>
              </div>
            </div>
          </div>
        </ContentPage>
    </>
    )

}

export default RolePage;